export const getSegmentKey = (platform: 'web' | 'webview', serverEnv: 'prod' | 'stg' | 'sandbox' | 'dev'): string => {
  const envKey = serverEnv === 'prod' ? 'prod' : 'dev';
  return {
    web: {
      prod: 'ASWXFZKmd8UJUZCfdmzGGy4wBWFLLrQq',
      dev: 'aIMLYk89XJe59ElUFcns4CFzd18iyHSQ',
    },
    webview: {
      prod: 'cDKavoQO1iNPKUBTpQ4uVzTHUhBCguCm',
      dev: 'v4SSN8lXHO0mRrqtzobLXEO0NB6t4NZH',
    },
  }[platform][envKey];
};
